import { render, staticRenderFns } from "./artigos.vue?vue&type=template&id=6677f000&"
import script from "./artigos.vue?vue&type=script&lang=js&"
export * from "./artigos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports